import { Route } from "react-router-dom";
import { _adr } from "../address";
import { Roles } from "../tools/services";
import { ProtectedRoute } from "../tools/protectedRoute";
import ViewProfile from "../components/acounts/profile/viewProfile";
import Changepassword from "../components/acounts/changepassword/changepassword";
import AccountInfo from "../components/acounts/acountInfo/account-info/accountInfo";
import Accountlist from "../components/acounts/acountInfo/account-list/accountlist";
import Notification from "../components/notification/notification";

export const accountRoutes = [
	<Route
		key="account-view-profile"
		path={_adr.Root + _adr.Accounts.Index + _adr.Accounts.ViewProfile}
		element={<ProtectedRoute role={Roles.Global} element={ViewProfile} />}
	/>,
	<Route
		key="account-change-password"
		path={_adr.Root + _adr.Accounts.Index + _adr.Accounts.ChangePassword}
		element={<ProtectedRoute role={Roles.Global} element={Changepassword} />}
	/>,
	<Route
		key="account-info"
		path={_adr.Root + _adr.Accounts.Index + _adr.Accounts.AccountInfo}
		element={<ProtectedRoute role={Roles.Global} element={AccountInfo} />}
	/>,
	<Route
		key="account-list"
		path={_adr.Root + _adr.Accounts.Index + _adr.Accounts.AccountList}
		element={<ProtectedRoute role={Roles.Global} element={Accountlist} />}
	/>,
	<Route
		key="notification"
		path={_adr.Root + _adr.Notification.Index}
		element={<ProtectedRoute role={Roles.Global} element={Notification} />}
	/>,
];
